<template>
  <div class="activity-iframe-wrap">
    <iframe
      v-if="url"
      :src="url"
      frameborder="0"
      style="width:100%; height:100%;"
    ></iframe>
  </div>
</template>
<script>
export default {
  name: 'activityBillList',
  data () {
    return { url: undefined }
  },
  created () {
    // console.log("currentEnv----:", currentEnv);
    const token = localStorage.getItem('token')
    const shop_id = localStorage.getItem('shop_id')
    const supplier_id = localStorage.getItem('supplier_id')
    const url =
      currentEnv == 'dev'
        ? 'http://dev.pro.ruigushop.com/activity-list'
        : currentEnv == 'test'
          ? 'https://test-pro.ruigushop.com/activity-list'
          : 'https://pro.ruigushop.com/activity-list'
    this.url =
      url +
      `?shop_id=${shop_id}&access_token=${token}&type=shop&purchase_channel=4&supplier_id=${supplier_id}`
  }
}
</script>
<style lang="scss" scoped>
.activity-iframe-wrap {
  width: 100%;
  height: calc(100vh - 53px - 40px);
}
</style>



// WEBPACK FOOTER //
// src/pages/r4SettlementReport/activity/index.vue